import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Livecoding #16: canvas.drawImage performance is weird but magical",
  "description": "",
  "published": "2016-07-26T00:00:00.000Z",
  "redirect_from": ["/blog/livecoding-16-canvas-drawimage-performance-is-weird-but-magical/swizec/6881"],
  "categories": "canvas, Front End, JavaScript, Livecoding, livecoding, react, Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`This is a Livecoding Recap – an almost-weekly post about interesting things discovered while livecoding. Shorter than 500 words. With pictures. You can follow my channel, `}<a parentName="em" {...{
          "href": "https://livecoding.tv/swizec"
        }}>{`here`}</a>{`. New content almost `}<strong parentName="em">{`every Sunday at 2pm PDT`}</strong>{`. There’s live chat ?`}</em></p>
    <p>{`This week, I had the charisma of a peeled potato. The livestream started with 6 people in the chat, and it ended with 2. Usually it ends with … more.`}</p>
    <p>{`So sad.`}</p>
    <p>{`BUT! We learned stuff about `}<inlineCode parentName="p">{`canvas.drawImage`}</inlineCode>{`, `}<em parentName="p">{`and`}</em>{` I poked around after the stream and made this glorious bastard. 14,000 smoothly animated particles! `}{`\\`}{`o/`}</p>
    <p><img parentName="p" {...{
        "src": "/22f40bafeac54cad5d3763b92f6442e5/eSfblPT.gif",
        "alt": null
      }}></img></p>
    <p>{`Cool, huh? Such a shame it didn’t work during the stream. Then 3 people would’ve stayed!`}</p>
    <p>{`The first thing we tried was the concept of sprites. Instead of doing `}<inlineCode parentName="p">{`.arc`}</inlineCode>{` and `}<inlineCode parentName="p">{`.stroke`}</inlineCode>{` for every particle, you do it once, then copy-pasta that particle to other places like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// draw a sprite particle in componentDidMount
this.context.beginPath();
this.context.arc(1.5, 1.5, 1, 0, 2*Math.PI, false);
this.context.stroke();

// copy pasta particle

drawParticle(particle) {
   let { x, y } = particle;

   this.context.drawImage(this.canvas, 0, 0, 3, 3, x, y, 3, 3);
}
`}</code></pre>
    <p>{`Using `}<inlineCode parentName="p">{`.drawImage`}</inlineCode>{` like this tells canvas to take pixels from the top left corner and copy them to a new place. A fast operation in theory, but something went wrong for us.`}</p>
    <p><img parentName="p" {...{
        "src": "/bbe99221f677b93d6e16198b66fe8377/902lShK.gif",
        "alt": null
      }}></img></p>
    <p>{`Terrible. Even worse than before. Copying those few pixels thousands of times grinds our animation to a halt. With a few thousand elements, each frame render takes a few seconds.`}</p>
    <p>{`But at least the `}<inlineCode parentName="p">{`.drawImage`}</inlineCode>{`. approach makes it easy to render arbitrary images instead of particles. Instead of using `}<inlineCode parentName="p">{`this.canvas`}</inlineCode>{` as the source, you can use an arbitrary `}<inlineCode parentName="p">{`Image()`}</inlineCode>{` object, which you can fill with an image from any URL on the internet.`}</p>
    <p><img parentName="p" {...{
        "src": "/81ce43c5d684b307451ef389c8871dec/K3JIWBY.gif",
        "alt": null
      }}></img></p>
    <p>{`Strange … that feels smoother, doesn’t it? I’m not going crazy, right?`}</p>
    <p>{`Anyway, there’s only one thing left to do: decouple physics from frame rate. A big part of why the animation feels so slow is that we only calculate new particle positions once per frame, which makes sense because we’re only drawing them once per frame.`}</p>
    <p>{`Our frame rate is not up to snuff for that. We’re dropping frames, so we have to compensate for that in our calculation. The idea is that for each drawn frame, we have to pretend like multiple physics frames happened.`}</p>
    <p>{`Fixing physics happens in the reducer and looks like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// reducer

case ‘TIME_TICK’:
        let {svgWidth, svgHeight, lastFrameTime} = state,
            newFrameTime = new Date(),
            multiplier = (newFrameTime-lastFrameTime)/(1000/60); // N frames dropped

        let movedParticles = state.particles
                                  .filter((p) => {
                                      return !(p.y > svgHeight || p.x < 0 || p.x > svgWidth);
                                  })
                                  .map((p) => {
                                      let [vx, vy] = p.vector;
                                      p.x += vx*multiplier;
                                      p.y += vy*multiplier;
                                      p.vector[1] += Gravity*multiplier;
                                      return p;
                                  });

        return Object.assign({}, state, {
            particles: movedParticles,
            lastFrameTime: new Date()
        });
`}</code></pre>
    <p>{`We start by tracking timestamps for each frame and calculating a multiplier. Then, we multiply every position and vector change with the multiplier and voilà: time-based (instead of frame-based) physics.`}</p>
    <p><img parentName="p" {...{
        "src": "/8e27a05cb86d730b0acabde9e014b05e/tQ1aiHw.gif",
        "alt": null
      }}></img></p>
    <p>{`So smooth! I had to increase the number of particles generated on every animation tick up to 2000 just to see anything interesting going on. Insane.`}</p>
    <p>{`Mission accomplished, right? It’s smooth up to 8,000 particles, and we can’t push it to put more than that on-screen. But the minions wouldn’t stop niggling at me.`}</p>
    <p>{`I wonder what happens if we put the minion sprite and the better physics together.`}</p>
    <p><img parentName="p" {...{
        "src": "/17eba15bcbb90a35ac9fa98149dfed79/JW4MSzk.gif",
        "alt": null
      }}></img></p>
    <p>{`Ho boy! 14,000 smoothly animated minions! `}{`\\`}{`o/`}</p>
    <p>{`With a production build and a big screen, you can reach over 20,000 minions on screen, and it still looks smooth. `}<a parentName="p" {...{
        "href": "http://swizec.github.io/react-particles-experiment/"
      }}>{`Try it.`}</a></p>
    <p>{`I have no idea why it’s faster to `}<inlineCode parentName="p">{`drawImage`}</inlineCode>{` a complex .png than a circle. Or why it’s faster to `}<inlineCode parentName="p">{`drawImage`}</inlineCode>{` an `}<inlineCode parentName="p">{`Image()`}</inlineCode>{` object than a part of the canvas. It makes no sense, but here we are.`}</p>
    <p>{`Do you know?`}</p>
    <p>{`PS: the edited and improved versions of these videos are becoming a video course. Readers of the engineer package of `}<a parentName="p" {...{
        "href": "http://swizec.com/reactd3js/"
      }}>{`React+d3js ES6`}</a>{` get the video course for free when it’s ready.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      